export default "__VITE_ASSET__DmQis_ZZ__"